if (window.psvaguidelines) {
  console.warn("Members Award JS already initialized");
} else {
  window.psvaguidelines = true;
  (function () {
    const block = document.getElementById("PSVA-guidelines");
    if (!block) return;
    const navList = block.querySelector("#PSVA-tab-nav-list");
    const dropdownBtn = block.querySelector("#PSVA-tab-dropdown-btn");
    let tabsData = [];
    try {
      tabsData = JSON.parse(block.dataset.tabs);
    } catch (e) {
      console.error("Tabs JSON parse error", e);
      return;
    }
    let activeIdx = 0;
    const triggers = block.querySelectorAll(".PSVA-tab-trigger");
    const panes = block.querySelectorAll(".PSVA-tab-pane");
    const prevWrapper = block.querySelector("#PSVA-prev-wrapper");
    const nextWrapper = block.querySelector("#PSVA-next-wrapper");
    const prevText = block.querySelector("#PSVA-prev-text");
    const nextText = block.querySelector("#PSVA-next-text");
    function titleToSlug(title) {
      return title
        .toLowerCase()
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-")
        .trim();
    }
    function getTabIndexFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      const tabParam = urlParams.get("tab");
      if (tabParam) {
        for (let i = 1; i < tabsData.length; i++) {
          const tabSlug = titleToSlug(tabsData[i].title);

          if (tabSlug === tabParam) {
            return i;
          }
        }
      }
      return 0;
    }
    function updateUrl(index) {
      const url = new URL(window.location.href);
      if (index > 0) {
        const tabSlug = titleToSlug(tabsData[index].title);
        url.searchParams.set("tab", tabSlug);
      } else {
        url.searchParams.delete("tab");
      }
      window.history.replaceState({}, "", url);
    }
    function scrollToSection() {
      const offset = 60;
      const elementPosition =
        block.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
    function syncUI(index, shouldScroll = false, updateUrlState = true) {
      activeIdx = parseInt(index);
      triggers.forEach((t, i) => {
        const isActive = i === activeIdx;
        t.classList.toggle("border-brand-dark-red", isActive);
        t.classList.toggle("text-brand-dark-red", isActive);
        t.classList.toggle("font-semibold", isActive);
        t.classList.toggle("border-transparent", !isActive);
        t.classList.toggle("text-brand-black", !isActive);
        t.classList.toggle("relative", isActive);
        t.classList.toggle("z-10", isActive);
        t.classList.toggle("-ml-[3px]", isActive);
      });
      panes.forEach((p, i) => {
        p.classList.toggle("hidden", i !== activeIdx);
      });
      prevWrapper.style.visibility = activeIdx > 0 ? "visible" : "hidden";
      nextWrapper.style.visibility =
        activeIdx < tabsData.length - 1 ? "visible" : "hidden";
      const nextLinkWrapper = block.querySelector("#PSVA-next-link-wrapper");
      if (nextLinkWrapper) {
        nextLinkWrapper.style.display = activeIdx > 0 ? "flex" : "none";
      }
      if (activeIdx > 0) {
        prevText.innerText = tabsData[activeIdx - 1].title;
      }
      if (activeIdx < tabsData.length - 1) {
        nextText.innerText = tabsData[activeIdx + 1].title;
      }
      block.querySelector("#PSVA-active-dropdown-label").innerText =
        tabsData[activeIdx].title;
      if (updateUrlState) {
        updateUrl(activeIdx);
      }
      if (shouldScroll) {
        setTimeout(scrollToSection, 100);
      }
    }
    const urlTabIndex = getTabIndexFromUrl();
    if (urlTabIndex > 0) {
      syncUI(urlTabIndex, false, false);
    } else {
      syncUI(0, false, false);
    }
    if (dropdownBtn) {
      dropdownBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        navList.classList.toggle("hidden");
        dropdownBtn.querySelector("svg").classList.toggle("rotate-180");
      });
    }
    triggers.forEach((t) => {
      t.addEventListener("click", () => {
        const index = parseInt(t.dataset.index);
        syncUI(index, false, true);
        scrollToSection();
        navList.classList.add("hidden");
        dropdownBtn.querySelector("svg").classList.remove("rotate-180");
      });
    });
    const prevBtn = block.querySelector("#PSVA-nav-prev");
    const nextBtn = block.querySelector("#PSVA-nav-next");
    if (prevBtn) {
      prevBtn.addEventListener("click", () => {
        if (activeIdx > 0) {
          syncUI(activeIdx - 1, true, true);
        }
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        if (activeIdx < tabsData.length - 1) {
          syncUI(activeIdx + 1, true, true);
        }
      });
    }
  })();
}
